import React from 'react';

/**
 * 🎨 COMPONENTE INPUT - Reutilizável
 * 
 * Campo de entrada de formulário flexível e reutilizável.
 * Usa TailwindCSS para estilização.
 * 
 * @param {string} label - Label do campo
 * @param {string} name - Nome do campo (atributo name)
 * @param {string} type - Tipo do input: 'text' | 'email' | 'password' | 'number' | etc.
 * @param {string} placeholder - Placeholder do campo
 * @param {any} value - Valor do campo
 * @param {function} onChange - Função chamada ao alterar valor
 * @param {string} error - Mensagem de erro (se houver)
 * @param {boolean} required - Se o campo é obrigatório
 * @param {boolean} disabled - Se o campo está desabilitado
 * @param {string} className - Classes CSS adicionais
 * @param {object} props - Outras props do HTML input
 */
const Input = ({
  label,
  name,
  type = 'text',
  placeholder,
  value,
  onChange,
  error,
  required = false,
  disabled = false,
  className = '',
  ...props
}) => {
  // Classes base do input
  const inputBaseClasses = `
    w-full 
    px-4 
    py-2 
    border 
    rounded-lg 
    transition-colors 
    duration-200
    focus:outline-none 
    focus:ring-2 
    focus:ring-offset-1
    disabled:bg-gray-100 
    disabled:cursor-not-allowed
  `;
  
  // Classes condicionais baseadas no estado
  const inputStateClasses = error
    ? 'border-red-500 focus:ring-red-500 focus:border-red-500'
    : 'border-gray-300 focus:ring-primary focus:border-primary';
  
  const inputClasses = `
    ${inputBaseClasses}
    ${inputStateClasses}
    ${className}
  `.trim().replace(/\s+/g, ' ');
  
  return (
    <div className="mb-4">
      {label && (
        <label 
          htmlFor={name} 
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          {label}
          {required && (
            <span className="text-red-500 ml-1" aria-label="obrigatório">*</span>
          )}
        </label>
      )}
      
      <input
        type={type}
        id={name}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        required={required}
        className={inputClasses}
        aria-invalid={error ? 'true' : 'false'}
        aria-describedby={error ? `${name}-error` : undefined}
        {...props}
      />
      
      {error && (
        <p 
          id={`${name}-error`}
          className="mt-1 text-sm text-red-600"
          role="alert"
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default Input;

